import type { QueryFilter } from '@schibsted-nmp/search-frontend-clients/quest';
import React from 'react';

export function useQueryValue(filter: QueryFilter) {
    const filterValue = filter.gs_value ?? '';
    const [queryValue, setQueryValue] = React.useState(filterValue);

    React.useEffect(() => {
        // Keep the query value in sync with the API response
        setQueryValue(filterValue);
    }, [filterValue]);

    return { queryValue, setQueryValue };
}
